import { Injectable } from "@angular/core";
import { SessionService } from "./session.service";

@Injectable({
  providedIn: 'root',
})
export class PermissionService {

  private roleActions: any;
  private roleFeatures: any;
  private companySettings: any;
  private enabledCompanyFeatures: any;
  private warmupPromise?: Promise<void>;

  isAdmin: boolean = false;

  constructor(private session: SessionService) {
    this.session.isAdmin$().subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });
  }

  warmUp(): Promise<void> {
    this.warmupPromise ??= (async () => {
      const [settings, actions, features] = await Promise.all([
        this.session.getCompanySettings(),
        this.session.GetPermissions('retailinsights:actions'),
        this.session.GetPermissions('retailinsights:features')
      ]);

      this.enabledCompanyFeatures = new Set(
        (settings.features ?? []).filter(f => f.isEnabled).map(f => f.id)
      );

      this.roleActions = new Set(actions ?? []);
      this.roleFeatures = new Set(features ?? []);
    })();

    return this.warmupPromise;
  }

  reset(): void {
    this.roleActions = undefined;
    this.roleFeatures = undefined;
    this.enabledCompanyFeatures = undefined;
    this.warmupPromise = undefined;
  }

  async hasActionPermissions(permission: any): Promise<boolean> {
    await this.warmUp();
    if((typeof permission) === "number"){
      return this.roleActions?.has(permission) ?? false;
    }
    else{
      const intersection = permission.filter((p:any) => this.roleActions.has(p));
      return intersection.length > 0;
    }
  }

  async hasFeaturePermissions(featureId: any): Promise<boolean> {
    await this.warmUp();
    const enabledByCompany = this.enabledCompanyFeatures?.has(featureId) ?? false;
    const enabledByRole = this.roleFeatures?.has(featureId) ?? false;

    return enabledByCompany && enabledByRole;
  }

  async companyHasFeaturePermissions(featureId: any): Promise<boolean> {
    await this.warmUp();

    const enabledByCompany = this.enabledCompanyFeatures?.has(featureId) ?? false;

    return enabledByCompany;
  }
}

export enum Permissions {
  None = 0,
  List = 1,
  View = 1 << 1,
  Update = 1 << 2,
  Insert = 1 << 3,
  Delete = 1 << 4,
  FullControl = 1 << 5
}
